import { generateSourcesForPicture } from '@farmersdog/corgi-x';

import foodPackagesWebP from './food-packages.webp';
import foodPackagesPng from './food-packages.png';

export const foodPackagesSources = generateSourcesForPicture({
  mobileSources: { png: foodPackagesPng, webP: foodPackagesWebP },
  desktopSources: { png: foodPackagesPng, webP: foodPackagesWebP },
});
